import { memo, useEffect } from "react";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AuthRoute = memo(function AuthRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);

  useEffect(() => {
    if (session.status === "authorized") {
      if (session?.user?.role === "admin") {
        navigate("/admin");
        return;
      }
      if (session?.user?.role === "user") {
        console.log("user");
        navigate("/dashboard");
        return;
      }
    }
  }, [session.status, navigate, session?.user?.role]);

  if (session.status === "loading") {
    return <LoadingFallback />;
  }

  return session.status === "unauthorized" ? children : null;
});

export default AuthRoute;
